import React from "react";
//import Table from "react-bootstrap/Table";

export const AuditLogsheaderTable = ({ date, operation, by }) => {
  return (
    <React.Fragment>
      <tr className="auditLogsheaderTable">
        <th className="f10-500 c_black">{date}</th>
        <th className="f10-500 c_black">{operation}</th>
        <th className="f10-500 c_black">{by}</th>
      </tr>
    </React.Fragment>
  );
};
